// extracted by mini-css-extract-plugin
export default {"content":"VI-z","lookName":"WI-z","shopTheLookContainer":"XI-z","productContainer":"YI-z","imageContainer":"ZI-z","mainImage":"_I-z"};